module.exports = __webpack_public_path__ + "static/media/Investment.0c4fafc0.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Misc/Contents/Investment.md
// module id = 1720
// module chunks = 0